import { Directive } from '@angular/core';

@Directive({
  selector: '[appRemarkAction]'
})
export class RemarkActionDirective {}
